import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-circle',
  templateUrl: './icon-circle.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCircleComponent {}
